import React from 'react';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonHitCard from 'Components/Card/HitCard/SkeletonHitCard';

// Featured, All, Games, Mystery, Books, Other
const PILLS = 6;

/**
 * Bundle pages (BundleCategoryPage) while they load, as the featured page at /bundle shows them: the title, the
 * bundle type pills beside the sort dropdown, and the Top Sellers grid (three large cards then rows of four, from xl).
 * The /bundle/:category grids have the same columns below xl. No slots.
 */
export default function BundleCategoryPageSkeleton() {
  return (
    <div className="BundleCategoryPageSkeleton">
      <div className="container BundleCategoryPageSkeleton__main">
        <SkeletonBlock className="SkeletonListing__title" />

        <div className="BundleCategoryPageSkeleton__bar">
          <div className="BundleCategoryPageSkeleton__pills">
            {[...Array(PILLS).keys()].map(i =>
              <SkeletonBlock key={i} className="BundleCategoryPageSkeleton__pill" />,
            )}
          </div>
          <SkeletonBlock className="BundleCategoryPageSkeleton__sort" />
        </div>
      </div>

      <section className="container">
        <SkeletonBlock className="SkeletonListing__heading" />

        <div className="SkeletonListing__grid BundleCategoryPageSkeleton__grid">
          <SkeletonHitCard numberOfCards={11} xsSize={12} smSize={12} mdSize={12} lgSize={12} />
        </div>
      </section>
    </div>
  );
}
